export default __webpack_public_path__ + "static/media/tfg-dropdown.f1d0030b.webp";